module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_novel2.35f82.png";